var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSection3Page(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19194 1.05806C9.43602 1.30214 9.43602 1.69786 9.19194 1.94194L2.13388 9L9.19194 16.0581C9.43602 16.3021 9.43602 16.6979 9.19194 16.9419C8.94786 17.186 8.55214 17.186 8.30806 16.9419L0.808058 9.44194C0.563981 9.19786 0.563981 8.80214 0.808058 8.55806L8.30806 1.05806C8.55214 0.813981 8.94786 0.813981 9.19194 1.05806Z",
    fill: "#72D49B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSection3Page);
export default __webpack_public_path__ + "static/media/MainSection3_Page.c153032415d9515254641fe0869770e8.svg";
export { ForwardRef as ReactComponent };